<template>
	<div class="container">
		<div class="row">
			<breadcrumb></breadcrumb>
			<sidebar></sidebar>
			<div class="col-sm-10">
				<section class="account-section">
					<div class="tab-content">
						<div id="shopping-cart-add" class="tab-pane fade in active">
							<shopping-cart-add></shopping-cart-add>
						</div>
						<div id="shopping-cart-address" class="tab-pane fade">
							<shopping-cart-address></shopping-cart-address>
						</div>
            <!-- DEPRECATED: the user cannot select the shipping anymore. -->
						<!-- <div id="shopping-cart-shipping" class="tab-pane fade">
							<shopping-cart-shipping></shopping-cart-shipping>
						</div> -->
						<div id="shopping-cart-payment" class="tab-pane fade">
							<shopping-cart-payment></shopping-cart-payment>
						</div>
						<div id="shopping-cart-summary" class="tab-pane fade">
							<shopping-cart-summary></shopping-cart-summary>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</template>

<style scoped>
	/*.tab-content{
		padding-left: 20px;
	}*/
</style>

<script>
import Breadcrumb from '../components/User/Breadcrumb.vue';
import Sidebar from '../components/User/Sidebar.vue';
import ShoppingCartAdd from '../components/Shopping-cart/Shopping-cart-add.vue';
import ShoppingCartAddress from '../components/Shopping-cart/Shopping-cart-address.vue';
import ShoppingCartShipping from '../components/Shopping-cart/Shopping-cart-shipping.vue';
import ShoppingCartPayment from '../components/Shopping-cart/Shopping-cart-payment.vue';
import ShoppingCartSummary from '../components/Shopping-cart/Shopping-cart-summary.vue';
import { router } from '../routes/routes';

export default {
	components: {
		Breadcrumb,
		Sidebar,
		ShoppingCartAdd,
		ShoppingCartAddress,
		ShoppingCartShipping,
		ShoppingCartPayment,
		ShoppingCartSummary,
	},

	vuex: {
		getters: {
			allow_continue: state => state.allow_continue
		}
	},

	methods: {
		removeAllows: function () {
			let vm = this;
			let a = vm.allow_continue;

			// Set in false all the allow sections.
			for (let i = 0; i < a.length; i++)
				a[i] = false;

			// Set the first one in true, where the user see
			// his products in the shopping cart.
			a[0] = true;
		}
	},

	ready: function () {
		let vm = this;

		// Before change the route check if the route if the same as
		// carrito-de-compra, if isn't remove the allow permissions
		// and the user starts the buy again.
		// router.afterEach(transition => {
		// 	if (vm.$route.name != 'carrito-de-compra')
		// 		vm.removeAllows();
		// });
	}
};
</script>



// WEBPACK FOOTER //
// Shopping-cart.vue?2dee72f3